/**
 * useToast - InToast 기반 명령형 toast 서비스.
 * 어디서든 toast.success('...') 호출 시 우상단에 InToast 가 뜨고 자동으로 사라진다.
 */
import { reactive } from 'vue';

const state = reactive({ toasts: [] });
let seq = 0;


// 표시 시간. 긴 문장이 읽기 전에 사라지지 않도록 글자 수에 비례해 늘린다(3~8초).
function readTime(message) {
  const n = String(message ?? '').length;
  return Math.min(8000, Math.max(3000, 1500 + n * 90));
}

function push(status, message, opts = {}) {
  const id = ++seq;
  const duration = opts.duration ?? readTime(message);
  const toast = { id, status, message: String(message ?? ''), closable: opts.closable === true, opaque: opts.opaque === true, _timer: null };
  state.toasts.push(toast); // 화면을 띄움.
  if (duration > 0) toast._timer = setTimeout(() => remove(id), duration);
  return id;
}

function remove(id) {
  const i = state.toasts.findIndex((t) => t.id === id);
  if (i >= 0) {
    const [removed] = state.toasts.splice(i, 1);
    if (removed && removed._timer) clearTimeout(removed._timer);
  }
}

export function useToastState() {
  return state;
}

/** 컴포넌트/composable 에서 호출하는 명령형 API (ElMessage 대체). */
export function useToast() {
  return {
    success: (message, opts) => push('success', message, opts),
    warning: (message, opts) => push('warning', message, opts),
    error: (message, opts) => push('error', message, opts),
    info: (message, opts) => push('enabled', message, opts), // InToast 에 'info' 없음 -> brand 'enabled'
    remove,
  };
}
